<ng-container *ifScreenSize="screenSize.Mobile">
  <fgb-page-header [pageTitle]="'wallet.page.title'" [showBalance]="false"></fgb-page-header>
</ng-container>
<div class="container">
  <ng-container *ifScreenSize="screenSize.Desktop">
    <div class="page-padding">
      <a class="cursor-pointer wallet-back-button mb-3" (click)="goBack()">
        <span class="icon material-symbols-outlined text-white"> arrow_back_ios_new </span>
      </a>
    </div>
  </ng-container>

  <fgbcl-auction-wallet-details [id]="id"></fgbcl-auction-wallet-details>
</div>
